module.exports = __webpack_public_path__ + "static/media/icon_bus_grey.18309b52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Icons/icon_bus_grey.svg
// module id = 805
// module chunks = 0